import { State } from '../../types';

export const westVirginia: State = {
  name: 'West Virginia',
  abbreviation: 'WV',
  terms: [
    {
      word: 'Cairo',
      phonetic: 'KAIR-oh',
      // audioUrl: '/audio/cairo.mp3',
      description: 'A town in Ritchie County, pronounced "KAIR-oh," not like the Egyptian capital.'
    },
    {
      word: 'Canaan Valley',
      phonetic: 'kuh-NANE VAL-lee',
      // audioUrl: '/audio/canaan_valley.mp3',
      description: 'A region in Tucker County, pronounced "kuh-NANE," not like the biblical "Canaan."'
    },
    {
      word: 'Elkins',
      phonetic: 'EL-kins',
      audioUrl: '/audio/sequim.mp3',
      description: 'A city in West Virginia, often mispronounced as "El-KANZ."'
    },
    {
      word: 'Hurricane',
      phonetic: 'HURR-ih-kun',
      // audioUrl: '/audio/hurricane.mp3',
      description: 'A city in Putnam County, pronounced "HURR-ih-kun," not like the storm.'
    },
    {
      word: 'Kanawha',
      phonetic: 'kuh-NAW',
      // audioUrl: '/audio/kanawha.mp3',
      description: 'A county and river, pronounced "kuh-NAW," with a silent "w."'
    },
    {
      word: 'Monongahela',
      phonetic: 'muh-NONG-guh-hee-luh',
      audioUrl: '/audio/sequim.mp3',
      description: 'Refers to the Monongahela National Forest and River, often mispronounced as "Mon-on-guh-HEE-luh."'
    },
    {
      word: 'Ronceverte',
      phonetic: 'RON-suh-vert',
      // audioUrl: '/audio/ronceverte.mp3',
      description: 'A city in Greenbrier County, pronounced "RON-suh-vert," not "ron-suh-VER-tay."'
    },
    {
      word: 'Sophia',
      phonetic: 'SO-fee-uh',
      // audioUrl: '/audio/sophia.mp3',
      description: 'A town in Raleigh County, pronounced "SO-fee-uh," with emphasis on the first syllable.'
    }
  ]
};